// @flow

import type { PendingIncomingPayment } from './types';

export function getSafePromptpayQRCode(incomingPayment: PendingIncomingPayment): string {
  const promptpay = incomingPayment['promptpay'];
  if(!promptpay){
    throw new Error('Promptpay: no promptpay data in incoming payment');
  }
  const promptpayQRCode = promptpay['qr_code_value'];
  if(!promptpayQRCode){
    throw new Error('Promptpay: no QR Code in incoming payment');
  }
  return promptpayQRCode;
}
